import { render, staticRenderFns } from "./renwufwlist_ios.vue?vue&type=template&id=556ed809&"
import script from "./renwufwlist_ios.vue?vue&type=script&lang=js&"
export * from "./renwufwlist_ios.vue?vue&type=script&lang=js&"
import style0 from "./renwufwlist_ios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556ed809')) {
      api.createRecord('556ed809', component.options)
    } else {
      api.reload('556ed809', component.options)
    }
    module.hot.accept("./renwufwlist_ios.vue?vue&type=template&id=556ed809&", function () {
      api.rerender('556ed809', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/renwufwlist_ios.vue"
export default component.exports